(function () {
    angular.module('tmx-app').factory('TenantFieldSetupService', ['tmxResource', 'lookupService', '$q', 'cacheStore', 'ToastService', 'tmxUtility',

        function TenantFieldSetupService(tmxResource, lookupService, $q, cacheStore, ToastService, tmxUtility) {
            var service = tmxResource("TenantFieldSetup");
            service.getScreens = lookupService.getScreens;
            //var roleId = 0;
            service.getScreenByProductId = function (productId, readonly, joint) {
                //roleId = Object.keys(JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).roles)[0];
                localStorage.getItem('culture') == null ? localStorage.setItem('culture', APP_CONSTANTS.default_culture) : '';
                var deferred = $q.defer();
                var cacheValues = cacheStore.get("TenantFields/" + productId + "/" + localStorage.getItem('culture'));
                if (angular.isDefined(cacheValues)) {
                    TenantFieldCallback(cacheValues);
                    deferred.resolve(cacheValues);
                }
                else {
                    service.getByAction("GetFieldsByProduct/" + productId + '/' + localStorage.getItem('culture')).then(TenantFieldCallback);
                }
                return deferred.promise;


                function TenantFieldCallback(response) {
                    localStorage.getItem('culture') == null ? localStorage.setItem('culture', APP_CONSTANTS.default_culture) : '';
                    cacheStore.set("TenantFields/" + productId + "/" + localStorage.getItem('culture'), angular.copy(response));
                    // For table to work make sure all its children ids are added in below array and IsDisabled of table is not equals to 1
                    var tableLookupId = lookupService.getFIELDHiddenValueByVisibleValue('Table');
                    var allFields = [];
                    var tabList = [...response.data.Tabs];
                    var listOfTenantFieldSetupIdOfTable = [];

                    if (!tmxUtility.exists(response.data.Tabs)) {
                        ToastService.showCustomToast("error", "No Tabs Found");
                        return;
                    }

                    function extractFields(tab) {
                        if (tmxUtility.exists(tab.Tabs) && tab.Tabs.length > 0) { // for sub tabs
                            tab.Tabs.forEach(extractFields);
                        }
                        allFields.push.apply(allFields, tab.Fields);
                    }

                    tabList.forEach(extractFields);

                    allFields.forEach(function (field) {
                        if (field.FieldTypeLkp == tableLookupId) {
                            listOfTenantFieldSetupIdOfTable.push(field.TenantFieldSetupId);
                        }
                    })
                    function preProcessFields(tab) {
                        if (tmxUtility.exists(tab.Tabs) && tab.Tabs.length > 0) { // for sub tabs
                            tab.Tabs.forEach(preProcessFields);
                        }
                        if (tmxUtility.exists(tab.Fields)) {
                            tab.Fields.forEach(function (field) {
                                try {
                                    if (readonly) {
                                        field.IsDisabled = true;
                                    }
                                    if (listOfTenantFieldSetupIdOfTable.indexOf(field.ParentTenantFieldSetupId) == -1) { // remove ParentTenantFieldSetupId of all other fields except table itself
                                        field._ParentFieldId = field.ParentTenantFieldSetupId;
                                        field.ParentTenantFieldSetupId = null;
                                    }

                                    if (field.FieldTypeLkp == 38) {
                                        field.FieldTypeLkp = 25;
                                    }
                                    if (field.FieldName == 'Empty' && field.FieldTypeLkp != 27) {
                                        field.FieldTableName = 'Empty';
                                    }
                                    //   field.FieldTableName = field.FieldTableName.replace('[]','');
                                    field.FieldTableName = field.FieldTableName.replace('[', '{');
                                    field.FieldTableName = field.FieldTableName.replace(']', '}');
                                    field.FieldTableName = field.FieldTableName.replace('{}', '[]');
                                }
                                catch (e) {
                                    console.log(`Error in TFS`, tab, field, e);
                                }
                            });
                        }
                    }

                    tabList.forEach(preProcessFields);
                    response.data = [response.data];
                    deferred.resolve(response);
                }
            }

            service.getAccountApplicationScreenByProductId = function (productId, readonly, joint) {
                localStorage.getItem('culture') == null ? localStorage.setItem('culture', APP_CONSTANTS.default_culture) : '';
                var deferred = $q.defer();
                var cacheValues = cacheStore.get("TenantFields/" + productId + "/" + localStorage.getItem('culture'));
                if (angular.isDefined(cacheValues)) {
                    TenantFieldCallback(cacheValues);
                    deferred.resolve(cacheValues);
                }
                else {
                    service.getByAction("GetFieldsByProduct/" + productId + '/' + localStorage.getItem('culture')).then(TenantFieldCallback);
                }
                return deferred.promise;


                function TenantFieldCallback(response) {
                    localStorage.getItem('culture') == null ? localStorage.setItem('culture', APP_CONSTANTS.default_culture) : '';
                    cacheStore.set("TenantFields/" + productId + "/" + localStorage.getItem('culture'), angular.copy(response));
                    // For table to work make sure all its children ids are added in below array and IsDisabled of table is not equals to 1
                    var tableLookupId = lookupService.getFIELDHiddenValueByVisibleValue('Table');
                    var allFields = [];
                    var tabList = [...response.data.Tabs];
                    var listOfTenantFieldSetupIdOfTable = [];

                    if (!tmxUtility.exists(response.data.Tabs)) {
                        ToastService.showCustomToast("error", "No Tabs Found");
                        return;
                    }

                    function extractFields(tab) {
                        if (tmxUtility.exists(tab.Tabs) && tab.Tabs.length > 0) { // for sub tabs
                            tab.Tabs.forEach(extractFields);
                        }
                        allFields.push.apply(allFields, tab.Fields);
                    }

                    tabList.forEach(extractFields);

                    allFields.forEach(function (field) {
                        if (field.FieldTypeLkp == tableLookupId) {
                            listOfTenantFieldSetupIdOfTable.push(field.TenantFieldSetupId);
                        }
                    });

                    function preProcessFields(tab) {
                        if (tmxUtility.exists(tab.Tabs) && tab.Tabs.length > 0) { // for sub tabs
                            tab.Tabs.forEach(preProcessFields);
                        }
                        if (tmxUtility.exists(tab.Fields)) {
                            tab.Fields.forEach(function (field) {
                                try {
                                    if (readonly) {
                                        field.IsDisabled = true;
                                    }
                                    if (listOfTenantFieldSetupIdOfTable.indexOf(field.ParentTenantFieldSetupId) == -1) { // remove ParentTenantFieldSetupId of all other fields except table itself
                                        field._ParentFieldId = field.ParentTenantFieldSetupId;
                                        field.ParentTenantFieldSetupId = null;
                                    }

                                    if (field.FieldTypeLkp == 38) {
                                        field.FieldTypeLkp = 25;
                                    }
                                    if (field.FieldName == 'Empty' && field.FieldTypeLkp != 27) {
                                        field.FieldTableName = 'Empty';
                                    }
                                    //   field.FieldTableName = field.FieldTableName.replace('[]','');
                                    field.FieldTableName = field.FieldTableName.replace('[', '{');
                                    field.FieldTableName = field.FieldTableName.replace(']', '}');
                                    field.FieldTableName = field.FieldTableName.replace('{}', '[]');
                                }
                                catch (e) {
                                    console.log(`Error in TFS`, tab, field, e);
                                }
                            });
                        }
                    }

                    tabList.forEach(preProcessFields);

                    response.data.Tabs = tabList;
                    response.data = [response.data];
                    deferred.resolve(response);
                }
            }

            service.getScreensByLoanAppId = function (loanAppId, readonly, joint) {
                var deferred = $q.defer();
                tmxResource("LoanApplication").getById(loanAppId).then(function (loanApp) {
                    if (loanApp.data.LoanProductId) {
                        service.getScreenByProductId(loanApp.data.LoanProductId, readonly, joint).then(function (_screen) {
                            var data = [];
                            data['pageSchema'] = _screen;
                            data['loanApplicationData'] = loanApp;
                            deferred.resolve(data);
                        });
                    }
                    else {
                        console.error('No product found for this application');
                    }
                });
                return deferred.promise;
            }

            service.getScreensByAccountAppId = function (accountAppId, readonly, joint) {
                var deferred = $q.defer();
                tmxResource("AccountApplication").getById(accountAppId).then(function (loanApp) {
                    if (loanApp.data.ProductId) {
                        service.getAccountApplicationScreenByProductId(loanApp.data.ProductId, readonly, joint).then(function (_screen) {
                            var data = [];
                            data['pageSchema'] = _screen;
                            data['accountApplicationData'] = loanApp;
                            deferred.resolve(data);
                        });
                    }
                    else {
                        console.error('No application found for this application');
                    }
                });
                return deferred.promise;
            }
            service.getScreensByTradeAppId = function (AppId, readonly, joint) {
                var deferred = $q.defer();
                tmxResource("Transaction").getById(AppId).then(function (tradeApp) {
                    if (tradeApp.data.ProductId) {
                        service.getScreenByProductId(tradeApp.data.ProductId, readonly, joint).then(function (_screen) {
                            var data = [];
                            data['pageSchema'] = _screen;
                            data['tradeAppData'] = tradeApp;
                            deferred.resolve(data);
                        });
                    }
                    else {
                        console.error('No product found for this application');
                    }
                });
                return deferred.promise;
            }

            service.getScreensByTradeProductId = function(ProductId, readonly, joint, tradeApp) {
                var deferred = $q.defer();
                service.getScreenByProductId(ProductId, readonly, joint).then(function (_screen) {
                    var data = [];
                    data['pageSchema'] = _screen;
                    data['tradeAppData'] = tradeApp;
                    deferred.resolve(data);
                });
                return deferred.promise;
            }
            return service;
        }]);
})();